import routerOptions0 from "/builds/aschehoug/aschehoug-utdanning/shop-app/node_modules/.pnpm/nuxt@4.2.2_@azure+identity@4.13.0_@parcel+watcher@2.5.1_@types+node@24.10.1_@vue+compiler-sfc_l3nsa5ukhbotzjub7wsb6zvnji/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}